import { FC, useCallback, useContext, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import AccountForm from '../components/accounts/AccountForm'
import ContentWithHeader from '../components/shared/ContentWithHeader'
import { useToast } from '../components/shared/ToastProvider'
import Account from '../domain/model/account'
import { AccountServiceContext } from '../service/ServiceContext'

type Params = {
  accountId: string
}

const EditAccountPage: FC = () => {
  const navigate = useNavigate()

  const { accountId } = useParams<Params>()
  const { state: accounts, update: updateAccount } = useContext(AccountServiceContext)
  const { showToast } = useToast()
  const selectedAccount = useMemo(() => accounts.find((c) => c.id === parseInt(accountId!)), [accounts, accountId])

  const onSubmit = useCallback(
    async (data: Partial<Omit<Account, 'id' | 'hasName'>>) => {
      if (typeof selectedAccount === 'undefined') return

      await updateAccount({ id: selectedAccount!.id }, data)

      showToast('Account updated')
      navigate(-1)
    },
    [updateAccount, selectedAccount, navigate, showToast],
  )

  if (typeof selectedAccount === 'undefined') {
    navigate('/accounts', { replace: true })
    return null
  }

  return (
    <ContentWithHeader title="Edit account" action="return" withPadding withScrolling>
      <AccountForm onSubmit={onSubmit} submitText="Save changes" initialAccount={selectedAccount} />
    </ContentWithHeader>
  )
}

export default EditAccountPage
